import React from 'react';
import ReactDOM from 'react-dom/client';

import '@link/china-railway/i18n';
import '@link/china-railway/styles/index.css';
import App from '@link/china-railway/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
